import React from 'react'
import { IntegrationsWooCommerceSec } from './integrationsWooCommerceSec'

export const IntegrationsWooCommerce = () => {
  return (
    <IntegrationsWooCommerceSec />
  )
}
